import { sanitizeRich } from "@/lib/richText";

export const RichContent = ({ html, className, testId }) => (
  <div className={className} data-testid={testId} dangerouslySetInnerHTML={{ __html: sanitizeRich(html) }} />
);
